import React, { useState, useEffect, useCallback } from 'react'
import { CCard, CCardBody, CCardHeader, CCol, CRow } from 'compat/coreui'
import axios from 'axios';
import { toast } from 'react-toastify';
import { getData } from '../../../helpers/api';
import { IMAGE_URL } from '../../../Constants/constants';

const API = process.env.REACT_APP_APP_API_URL;

// One page for every shop image: logo, cover, and the photo gallery.
// Files upload the moment they're picked.
export default function Gallery() {
    const [user, setUser] = useState({});
    const [busy, setBusy] = useState('');

    const load = useCallback(() => {
        getData(`${API}/api/user`).then(res => {
            if (res.data.status) setUser(res.data.user || {});
        }).catch(() => {});
    }, []);

    useEffect(() => { load() }, [load]);

    const upload = (endpoint, label) => async (e) => {
        const file = e.target.files && e.target.files[0];
        if (!file) return;
        setBusy(label);
        const formData = new FormData();
        formData.append('photos', file);
        try {
            const res = await axios.post(`${API}/api/${endpoint}`, formData, {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
            });
            if (res.status === 200) {
                toast.success(`${label} updated`);
                load();
            }
        } catch (err) {
            toast.error(`Could not upload the ${label.toLowerCase()}`);
        } finally {
            setBusy('');
            e.target.value = '';
        }
    };

    const uploader = (label, endpoint, hint) => (
        <label className="bp-upload-tile">
            <input type="file" accept="image/*" onChange={upload(endpoint, label)} hidden />
            <span className="bp-upload-ico" aria-hidden="true">{busy === label ? '⏳' : '⬆️'}</span>
            <strong>{busy === label ? 'Uploading…' : `Upload ${label}`}</strong>
            <small className="text-muted">{hint}</small>
        </label>
    );

    return (
        <>
            <CRow className="mb-3">
                <CCol>
                    <h2 style={{ fontWeight: 800, marginBottom: 4 }}>Photos</h2>
                    <p className="text-muted">Your logo, cover, and gallery — this is your shop's face on the marketplace.</p>
                </CCol>
            </CRow>
            <CRow>
                <CCol xl={4} className="mb-4">
                    <CCard>
                        <CCardHeader>Logo</CCardHeader>
                        <CCardBody className="text-center">
                            <div className="bp-shop-avatar" style={{ margin: '0 auto 16px', width: 96, height: 96 }}>
                                <img alt="" src={user.image ? IMAGE_URL + user.image : '/images/placeholder.svg'} />
                            </div>
                            {uploader('Logo', 'profilepic', 'Square works best · JPEG/PNG')}
                        </CCardBody>
                    </CCard>
                </CCol>
                <CCol xl={8} className="mb-4">
                    <CCard>
                        <CCardHeader>Cover</CCardHeader>
                        <CCardBody className="text-center">
                            <div className="bp-cover-preview">
                                {user.coverImage
                                    ? <img alt="" src={IMAGE_URL + user.coverImage} />
                                    : <div className="bp-biz-cover-fallback" />}
                            </div>
                            {uploader('Cover', 'coverimg', 'Wide banner shown on top of your shop page · ~1200×300')}
                        </CCardBody>
                    </CCard>
                </CCol>
            </CRow>
            <CRow>
                <CCol className="mb-4">
                    <CCard>
                        <CCardHeader>Gallery <small className="text-muted">shown on your shop's Photos tab</small></CCardHeader>
                        <CCardBody>
                            <div className="bp-photo-grid">
                                {(user.promoImage || []).map((p, i) => (
                                    <div className="bp-photo" key={i}>
                                        <img alt="" src={IMAGE_URL + p} />
                                    </div>
                                ))}
                                {uploader('Photo', 'promopics', 'Add product shots, your storefront, your team…')}
                            </div>
                        </CCardBody>
                    </CCard>
                </CCol>
            </CRow>
        </>
    )
}
